import error from "@/assets/videos/404-Page.gif";
import { Link } from "react-router-dom";
const Error = () => {
  return (
    <div className="w-full">
      <img src={error} alt="error" />
      <Link to={"/"}>
        <p>Go Back To Home</p>
      </Link>
    </div>
  );
};

export default Error;
